/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletIcon16Regular = forwardRef('TextBulletIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3 5.25A1.251 1.251 0 1 0 3 2.75a1.251 1.251 0 0 0 0 2.502Z" }),
        React.createElement("path", { d: "M6 4a.75.75 0 0 1 .75-.75H13a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 4Z" }),
        React.createElement("path", { d: "M6.75 7.25a.75.75 0 0 0 0 1.5H13a.75.75 0 0 0 0-1.5H6.75Z" }),
        React.createElement("path", { d: "M6.75 11.25a.75.75 0 0 0 0 1.5H13a.75.75 0 0 0 0-1.5H6.75Z" }),
        React.createElement("path", { d: "M3 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" }),
        React.createElement("path", { d: "M4.25 8A1.251 1.251 0 1 1 1.75 8a1.251 1.251 0 0 1 2.502 0Z" })));
});
